"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mixinXcrud = _interopRequireDefault(require("@/libs/flowable/common/mixinXcrud"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  mixins: [_mixinXcrud.default],
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: true,
      formData: {
        paramList: this.value
      }
    };
  },
  computed: {
    formConfig: function formConfig() {
      return {
        inline: false,
        item: [{
          xType: 'tabs',
          tabs: [{
            label: '监听器参数',
            name: 'paramList',
            column: [{
              label: '类型',
              name: 'type',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'select',
              dic: [{
                label: '字符串',
                value: 'stringValue'
              }, {
                label: '表达式',
                value: 'expression'
              }]
            }, {
              label: '名称',
              name: 'name',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'input'
            }, {
              label: '值',
              name: 'value',
              xType: 'input',
              rules: [{
                required: true,
                message: '请输入',
                trigger: ['blur', 'change']
              }]
            }]
          }]
        }]
      };
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      var _this = this;
      this.$refs.xForm.validate().then(function () {
        _this.dialogVisible = false;
      }).catch(function (e) {
        return console.error(e);
      });
    }
  }
};